import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    services: [
      { label: 'Plant Sales', href: '/login' },
      { label: 'Landscaping', href: '/contact' }
    ],
    resources: [
      { label: 'Garden Guide', href: '#' },
      { label: 'Plant Care', href: '#' }
    ],
    company: [
      { label: 'Home', href: '/' },
      { label: 'Careers', href: '/careers' },
      { label: 'Customer Login', href: '/login' }
    ],
    contact: [
      { label: 'Speak to Us', href: '/contact' }
    ]
  };

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', label: 'Facebook' },
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
    { icon: 'ri-pinterest-fill', href: '#', label: 'Pinterest' },
    { icon: 'ri-youtube-fill', href: '#', label: 'YouTube' }
  ];

  return (
    <footer id="contact" className="bg-[#1e3a2f] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
              <h3 className="text-3xl font-serif font-bold">GreenEmbers Wholesale Nursery</h3>
            </div>
            <p className="text-emerald-100 text-sm mb-6 max-w-md">
              Your trusted partner in creating and maintaining beautiful, sustainable gardens since 1998.
            </p>
            <div className="flex items-center gap-3">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-1 px-4 py-3 bg-transparent border-2 border-white/30 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white text-sm"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-emerald-500 rounded-lg hover:bg-emerald-600 transition-colors cursor-pointer">
                <i className="ri-notification-line text-xl text-white"></i>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-semibold mb-4">Services</h4>
              <ul className="space-y-2">
                {footerLinks.services.map((link, index) => (
                  <li key={index}>
                    {link.href.startsWith('/') ? (
                      <Link to={link.href} className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                        {link.label}
                      </Link>
                    ) : (
                      <a href={link.href} className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Resources</h4>
              <ul className="space-y-2">
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Company</h4>
              <ul className="space-y-2">
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    {link.href.startsWith('/') ? (
                      <Link to={link.href} className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                        {link.label}
                      </Link>
                    ) : (
                      <a href={link.href} className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <ul className="space-y-2">
                {footerLinks.contact.map((link, index) => (
                  <li key={index}>
                    <Link to={link.href} className="text-sm text-emerald-100 hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-sm text-emerald-100">
              © 2026 GreenEmbers Wholesale Nursery. All rights reserved.
            </p>

            <div className="flex items-center gap-5">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white hover:bg-white/10 transition-all cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
